"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.threads.title': 'Threads',
    'whatsapp.threads.count': 'Total',
    'whatsapp.threads.noThreads': 'No threads found.',
    'whatsapp.threads.noLogs': 'No track logs in this thread.',
    'whatsapp.threads.selectThread': 'Select a thread to view its track logs.',
    'whatsapp.threads.showFinished': 'Show finished',
    'whatsapp.threads.finished': 'Finished',
    'whatsapp.threads.finish': 'Finish',
    'whatsapp.threads.reopen': 'Reopen',
    'whatsapp.threads.back': 'Back',
    'whatsapp.threads.confirmFinish': 'Mark this thread as finished?',
    'whatsapp.threads.finishFailed': 'Failed to finish thread.',
    'whatsapp.threads.source.group': 'Group',
    'whatsapp.threads.source.email': 'Email',
    'whatsapp.threads.source.dm': 'Direct Message',
};
